import React from "react";
import { useHistory } from "react-router-dom";

type Props = {
  breadcrumb: Array<any>;
  icon: string;
};

const IconLeft: React.FC<Props> = ({ breadcrumb, icon }): JSX.Element => {
  let history = useHistory();

  return (
    <div
      className={`flex flex-col cursor-pointer mr-2 ${
        breadcrumb.length > 0 ? "mt-11" : ""
      }`}
      onClick={() => history.goBack()}
    >
      <img src={icon} alt="icon" width={25} />
    </div>
  );
};

export default IconLeft;
